import { type AiBuilderMessageAttachment } from './types';

const URL_PATTERN = /https?:\/\/[^\s]+/i;

export const createUserAttachment = (
  prompt: string,
  selectedFile: File | null,
): AiBuilderMessageAttachment | undefined => {
  if (selectedFile) {
    return {
      type: 'file',
      label: selectedFile.name,
      extension: getAiBuilderFileExtension(selectedFile.name),
    };
  }

  const url = prompt.match(URL_PATTERN)?.[0];

  if (!url) return undefined;

  return {
    type: 'url',
    label: url,
  };
};

export const getAiBuilderFileExtension = (fileName: string) => {
  const extension = fileName.split('.').pop()?.trim().toLowerCase();

  return extension && extension !== fileName.toLowerCase()
    ? extension
    : undefined;
};
